import { supabase } from '@/lib/supabase'

export type RoleVisionPolicy = {
  role: string
  vision_enabled: boolean
}

export type PlanVisionPolicy = {
  plan_id: string
  vision_enabled: boolean
}

export async function fetchRoleVisionPolicies(): Promise<RoleVisionPolicy[]> {
  const { data, error } = await supabase
    .from('role_vision_policies')
    .select('role,vision_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleVisionPolicy[]
}

export async function upsertRoleVisionPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_vision_policies')
    .upsert({ role, vision_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanVisionPolicies(): Promise<PlanVisionPolicy[]> {
  const { data, error } = await supabase
    .from('plan_vision_policies')
    .select('plan_id,vision_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanVisionPolicy[]
}

export async function upsertPlanVisionPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_vision_policies')
    .upsert({ plan_id: planId, vision_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}
